<template>
  <div id="top">
    <div class="content">
      <ContentHeader />
    </div>
    <div class="navigation" v-if="this.$vuetify.breakpoint.mdAndUp">
    <div v-if="lang=='nl'" class="main_div">
      <v-layout>
        <v-col class="ml-12" cols="1"></v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[0]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][2]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][4]}}</div>
                <div>{{voyages[item][10]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Ondek meer</a>
                </v-btn></div>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[1]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][2]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][4]}}</div>
                <div>{{voyages[item][10]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Ondek meer</a>
                </v-btn></div>
              </v-card-actions>


            </v-card>
          </div>
        </v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[2]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][2]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][4]}}</div>
                <div>{{voyages[item][10]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Ondek meer</a>
                </v-btn></div>
              </v-card-actions>


            </v-card>
          </div>
        </v-col>
      </v-layout>
      <Footer class="footer_photos mt-12" />
    </div>

    <div v-else class="main_div">
      <v-layout>
        <v-col class="ml-12" cols="1"></v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[0]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][3]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][5]}}</div>
                <div>{{voyages[item][11]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Discover More</a>
                </v-btn></div>
              </v-card-actions>


            </v-card>
          </div>
        </v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[1]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][3]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][5]}}</div>
                <div>{{voyages[item][11]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Discover More</a>
                </v-btn></div>
              </v-card-actions>


            </v-card>
          </div>
        </v-col>
        <v-col class="columns mt-5 view_photo" cols="3">
          <div v-for="item in sortedVoyage[2]" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][3]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][5]}}</div>
                <div>{{voyages[item][11]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Discover More</a>
                </v-btn></div>
              </v-card-actions>


            </v-card>
          </div>
        </v-col>
      </v-layout>
      <Footer class="footer_photos mt-12" />
    </div>
    </div>
    <div v-else>
       <div v-if="lang=='nl'" class="main_div">
      <v-layout>
        <v-col cols="1"></v-col>
        <v-col class="columns mt-5 view_photo" cols="10">
          <div v-for="item in sortedVoyagePhone" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][2]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][4]}}</div>
                <div>{{voyages[item][10]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Ondek meer</a>
                </v-btn></div>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-layout>
      <Footer class="footer_photos mt-12" />
    </div>
    <div v-else class="main_div">
      <v-layout>
        <v-col cols="1"></v-col>
        <v-col class="columns mt-5 view_photo" cols="10">
          <div v-for="item in sortedVoyagePhone" :key="item.id">
            <v-card class="mx-auto mt-10 card" max-width="400">
              <v-img class="white--text align-end photo" height="200px" :src="voyages[item][1]">
                <v-card-title class="ml-4">{{voyages[item][3]}}</v-card-title>
              </v-img>
              <v-card-subtitle class="pb-0 ml-4 mt-2">{{voyages[item][8]}} - {{voyages[item][9]}}</v-card-subtitle>
              <v-card-text class="text--primary ml-4">
                <div>{{voyages[item][5]}}</div>
                <div>{{voyages[item][11]}}</div>
              </v-card-text>
              <v-card-actions>
                <div class="text-center">
                     <v-btn class="ml-3 mb-3 mt-3"><a class="link" :href="voyages[item][12]" target="_blank" color="#2980b9" text>Ondek meer</a>
                </v-btn></div>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-layout>
      <Footer class="footer_photos mt-12" />
    </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../components/ContentHeader.vue";
import Footer from "../components/Footer.vue";
export default {
  name: "Travel",
  data() {
    return {
      lang: this.$route.params.lang,
      loading: true
    };
  },
  components: {
    ContentHeader,
    Footer
  },
  computed: {
    voyages() {
      var temp = this.$store.state.voyages;
      console.log("dit is temp")
      console.log(temp)
      var filtered = temp.filter(function(voy) {
        return voy.plaats_nederlands != "Beveren";
      });
      var res = {}
      for (var j = 0; j < filtered.length; j++) {
	var datum = Number(
          String(filtered[j]["start_datum"].slice(0, 4)) +
            String(filtered[j]["start_datum"].slice(5, 7)) +
            String(filtered[j]["start_datum"].slice(8, 11))
        );
	res[datum] = [
          filtered[j]["id"],
          filtered[j]["image"],
          filtered[j]["land_nederlands"],
          filtered[j]["land_engels"],
          filtered[j]["plaats_nederlands"],
          filtered[j]["plaats_engels"],
          filtered[j]["omschrijving"],
          filtered[j]["omschrijving_engels"],
          filtered[j]["start_datum"],
          filtered[j]["eind_datum"],
          filtered[j]["bird_list_nederlands"],
          filtered[j]["bird_list_engels"],
          filtered[j]["link"]
        ];
	
      }
      return res;
    },
    sortedVoyage() {
      var items = Object.keys(this.voyages)
        .sort()
        .reverse();
      var e1 = [];
      var e2 = [];
      var e3 = [];
      var index = 1;
      for (var i = 0; i < items.length; i++) {
        if (index == 1) {
          e1.push(items[i]);
          index = 2;
        } else if (index == 2) {
          e2.push(items[i]);
          index = 3;
        } else {
          e3.push(items[i]);
          index = 1;
        }
      }
      return [e1, e2, e3];
    },
    sortedVoyagePhone(){
      return Object.keys(this.voyages)
        .sort()
        .reverse();
    },
    photos() {
      return this.$store.state.photos;
    }
  },
  mounted() {
    this.$store.dispatch("getPhotoVoyage");
    this.loading=false;
  },
  watch: {
    $route: "update"
  },
  methods: {
    update() {
      this.lang = this.$route.params.lang;
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}
.footer {
  position: absolute;
  width: 100%;
}
.text {
  text-align: left;
}

.content {
  width: 100%;
  height: 10%;
  background-color: black;
  position: absolute;
  top: 0%;
}

.datum h5 {
  color: aqua;
}

.card_text {
  position: relative;
  top: 300px;
  left: 55%;
  z-index: 5;
  width: 30%;
}
.image {
  width: 120%;
  height: 100vh;
  z-index: 0;
}
.main_div {
  position: absolute;
  top: 10%;
  right: 0;
  left: 0;
}
.photos {
  width: 100%;
  position: absolute;
  top: 60%;
}
.photo {
  transform: scale(1);
  transition: transform 0.5s;
}
.photo:hover {
  transform: scale(1.05);
}
.card {
  margin-bottom: 75px;
  overflow: hidden;
}

.link {
  text-decoration: none;
}

.btn-link {
  font-weight: 200%;
}
</style>
